<template>
  <div>
    <v-row no-gutters v-if="questionData.length > 0">
        <v-col  sm="6" xs="6"> 
          <h3 class="headSectionPeriksa">Daftar Periksa</h3> 
        </v-col>
    </v-row>
    <v-row no-gutters  v-for="item of questionData" :key="item.questionId">
        <v-col sm="9" xs="9"> 
          <p class="headerInputPeriksa">{{item.question}}</p> 
        </v-col>
         <v-col  sm="2" xs="2"> 
           <v-select class="selectInput" :items='checkOptions' v-model="item.answer" label="Pilih" clearable />
        </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col sm="2" xs="4">
        <h3 class="headerSection" style='padding-left:26px; margin-top:25px'>File Laporan</h3>
      </v-col>
      <v-col sm="3" xs="4"  v-if="!docPelaporan || docPelaporan.size > 10000000" style="margin-top:10px">
        <v-file-input :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPelaporan"/>
          <template v-slot:selection="{ text }">
            <v-chip small label color="primary" >
              {{ text }}
            </v-chip>
          </template>
      </v-col>
      <v-col sm="5" xs="6"  v-if="docPelaporan && docPelaporan.size < 10000000" style='margin-top:25px'>
         <span> {{docPelaporan.name}} </span>
         <v-btn icon color="red" @click="deleteDocPelaporan('docPelaporan')">
           <v-icon> mdi-close</v-icon> 
         </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="1" style='margin-left:40px'>
        <v-btn color="blue-grey"  @click='handleBack()' block style='color:white '>
          Back
        </v-btn>
      </v-col>
      <v-col sm="1" style='margin-left:40px'>
         <v-btn   color='success' style='margin-left:-50px' @click='handleBubmit()' block :disabled='disableSubmit'>
           <v-icon>send</v-icon>&nbsp;Submit 
         </v-btn> 
      </v-col><br><br><br><br>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapState} from "vuex";
export default {
  name: "DaftarPeriksa",
  components: {},
  props: [],
  data() {
    return {
      docPelaporan: null,
      disableSubmit : true,
      uploadId : "",
      questionData :[],
      dataFormCode: "",
      rules: [
        (value) =>
          !value || value.size < 10000000 || "Ukuran file harus dibawah 10 MB!",
      ],
      checkOptions: ["Ya", "Tidak"],
    };
  },
  computed: {
    ...mapState(["API_URL", "dataQuestions","formIdQuestion","formCodeQuestions","PayloadQuestion"]),
  },
  mounted () {
    this.dataFormCode = this.$route.params.formCode;
    this.$store.dispatch('fetchDataQuestions', {_id: this.$route.params.permitId, ipForm: this.dataFormCode});
  },
  methods: {
    deleteDocPelaporan(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.uploadId = null
          this.docPelaporan = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    handleBack(){
      this.$router.push("/my-permit");
    },
    handleBubmit(){
      let dataQuestion = []
      if(this.questionData.length > 0){
        this.questionData.map(data =>{
        dataQuestion.push({
        questionId : data.questionId,
        answer : data.answer || ""
        })
      })
      }

      let newData = {
        formId :this.formIdQuestion,
        uploadId : this.uploadId.toString(),
        formCode : this.dataFormCode,
        answers : dataQuestion
      }
       axios.post(
          `${this.API_URL}/v1/pengesahan/submit`,newData,
          { headers: { Authorization: `Bearer ${this.$store.state.token}` } }
        )
        .then((res)=>{
          if(res.status == 200){
            this.$router.push("/my-permit");
          }
        })
        .catch((err)=>{
          console.log(err)
        })
    }
  },
  watch: {
    dataQuestions(param){
      this.questionData = param
    },
    formCodeQuestions(param){
      this.dataFormCode = param
    },
    docPelaporan(params) {
      if (params && params.size < 10000000) {
        this.uploadId = Date.now();
        let formData = new FormData();
        formData.append("uploadId", this.uploadId);
        formData.append("docPendukung", params);
        this.uploadId ? this.disableSubmit = false : this.disableSubmit = true;
        axios.post(
          `${this.API_URL}/v1/requests/attachment/docPendukung`,
          formData,
          { headers: { Authorization: `Bearer ${this.$store.state.token}` } }
        );
      }
    },
    uploadId(param){
       if(param === null){
        this.disableSubmit = true
       }
    }
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>